import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import WebHeader from './Components/WebHeader';
import HomePage from './WebsitePages/HomePage';
import WebFooter from './Components/WebFooter';
import './Assets/WebsiteCss/homepage.css'
import AboutUs from './WebsitePages/AboutUs';
import Services from './WebsitePages/Services';
import Products from './WebsitePages/Products';
import Contact from './WebsitePages/Contact';
import Team from './WebsitePages/Team';

import { useEffect, useState } from "react";
import { FaWhatsapp, FaArrowUp } from "react-icons/fa";
import PrivacyPolicy from './WebsitePages/PrivacyPolicy';
import TermsAndConditions from './WebsitePages/TermsAndConditions';
import ScrollToTop from './WebsitePages/ScrollToTop';


function App() {

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  return (
    <Router>
    
    <WebHeader />
   <div>
   <ScrollToTop/>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/services" element={<Services/>} />
      <Route path="/ourproducts" element={<Products />} />
      <Route path="/teamandachivements" element={<Team/>} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/termcondition" element={<TermsAndConditions />} />
      
    </Routes>

    <a
          href="https://api.whatsapp.com/send/?phone=919602910275&text=Hello%2C&type=phone_number&app_absent=0"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
        </a>
        {/* Scroll-To-Top Button */}
        
        {showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
    <FaArrowUp />
  </button>
)}

</div>

    <WebFooter/>
  </Router>
  );
}

export default App;
